<template>
    <div class="nqt--profile" ref="nqt--profile">
        <div class="top-content" :class="{mb: mobile}">
            <!-- Tìm kiếm -->
            <div class="manage--search-content--left student">
                <input type="text" autocomplete="off" v-model="keyword" :placeholder="$t('new.title69')" class="input--search--left" />
            </div>
            <div class="manage--search-content" v-if="!mobile">
                <button class="btn-details-course btn-details-course-not-list" v-if="isDownload" @click='$emit("download")'>{{$t('manage.downloadStudents')}}</button>
            </div>
            <div class="manage--search-content--right">
                <p>{{$t('schoolBusiness.all')}}</p>
                <span class="menu-switch-school" :class="{ 'menu-switch-school-on': showAll }" @click="setShowAll(!showAll)"></span>
            </div>
        </div>

        <!-- Nội dung -->
        <div class="box-ttct" v-if="students.length">
            <div class="nqt-list-study">
                <!-- Danh sách -->
                <template v-for="(item, index) in students">
                    <div class="nqt--card--student stBg" :key="index">
                        <h1 class="nqt--card-title">{{item.studentName}}</h1>
                        <div class="div-nd-hv">

                            <!-- Avatar -->
                            <template>
                                <img v-if="item.avatar == null" class="avatar-hv" :src="avaDefault" alt="avatar" />
                                <img v-else class="avatar-hv" :src="item.avatar" alt="avatar" />
                            </template>

                            <!-- Thông tin -->
                            <div class="nd-gt">
                                <div class="nqt--card-startStudyDate" style="-webkit-box-orient: vertical !important;">
                                    <label>{{$t('profile.email')}}:</label>
                                    <span class="lkt-h-20">{{item.email}}</span>
                                </div>
                                <div class="nqt--card-startStudyDate">
                                    <label>{{$t('profile.studyTime')}}:</label>
                                    <span class="lkt-h-20">{{item.studyTime}}</span>
                                </div>
                                <div class="nqt--card-sex">
                                    <label>{{$t('manage.sex')}}:</label>
                                    <span class="lkt-h-20" v-if="item.sex == 1">{{$t('manage_student.male')}}</span>
                                    <span class="lkt-h-20" v-if="item.sex == 2">{{$t('manage_student.female')}}</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </template>
            </div>
        </div>
        <!-- No data -->
        <div v-else>
            <img class="imgf" src="../../../../static/images/noresult.jpg" />
        </div>

    </div>
</template>

<script>
    import { mapState, mapMutations } from "vuex";

    export default {
        data() {
            return {
                avaDefault: "static/images/profile.jpg",
                keyword: null,
                loading: false
            };
        },
        computed: {
            // Tìm kiếm khóa học
            students: function () {
                let keyword = this.keyword;
                let result = [];

                if (keyword == null || keyword == "") {
                    result = this.data;
                } else {
                    keyword = keyword.toUpperCase();
                    result = this.data.filter(student => student.studentName.toUpperCase().indexOf(keyword) > -1);
                }
                if (!this.showAll) {
                    result = this.data.filter(student => student.userType == '2');
                }
                return result;
            },

            // Lấy dữ liệu từ store
            ...mapState({
                mobile: (state) => state.header.mobile,
                showAll: (state) => state.manageStudent.showAll
            }),
        },
        methods: {
            ...mapMutations("manageStudent", ["setShowAll"]),
        },
        props: {
            data: {
                type: Array,
                default: [],
            },
            isDownload: {
                type: Boolean,
                default: false
            },
        }
    };
</script>
<style scoped>
    .manage--search-content--left input {
        border-radius: 4px;
        border: 1px solid #DCDFE6;
        width: 100%;
    }
    .imgf {
        position: absolute;
        left: 50%;
        top: 50%;
        transform: translate(-50%, -50%);
        width: 150px;
    }
    .nd-gt {
        width: calc(100% - 70px) !important;
        text-overflow: ellipsis;
        overflow: hidden;
    }
    .nd-gt span {
        width: calc(100% - 130px) !important;
        white-space: nowrap;
        padding: 0 0 5px 14px;
    }
    .nqt-list-study {
        margin-top: 3px !important;
        width: 100%;
    }

    .nqt--card--student {
        /* cursor: pointer; */
        border: 1px solid #d7d7d7;
        position: relative;
    }
    .nqt--card--student label {
        /* cursor: pointer; */
        /* width: 130px; */
        width: auto;
        padding-bottom: 5px;
    }
    .avatar-hv {
        width: 70px;
        height: 70px;
        object-fit: contain;
    }
    @media (max-width: 480px) {
        .imgf {
            top: 64% !important;
        }
        .nd-gt div {
            flex-wrap: inherit;
        }
    }

    /* ---- */
    .nqt-pst-a {
        position: absolute !important;
    }
    .nqt-pd-0 {
        padding-top: 0;
    }
    .nqt-col-8 {
        -ms-flex: 0 0 66.666667%;
        flex: 0 0 66.666667%;
        max-width: 66.666667%;
        padding-left: 10px;
    }
    .nqt-t-r {
        text-align: right;
    }
    .mb-2 {
        margin-bottom: 2rem;
        margin-top: 2rem;
    }
    .nqt-lesons-sum {
        margin-top: 10px;
        margin-left: 25px;
        font-size: large;
    }
    .nqt--row {
        display: -ms-flexbox;
        display: flex;
        -ms-flex-wrap: wrap;
        flex-wrap: wrap;
    }
    .nqt-col-sm-3 {
        -ms-flex: 0 0 25%;
        flex: 0 0 25%;
        max-width: 25%;
        position: relative;
        width: 100%;
        padding-right: 15px;
        padding-left: 15px;
    }
    .nqt-col-sm-9 {
        -ms-flex: 0 0 75%;
        flex: 0 0 75%;
        max-width: 75%;
        position: relative;
        width: 100%;
        padding-right: 15px;
        padding-left: 15px;
        color: #6c757d !important;
    }
    .nqt-col-sm-5 {
        -ms-flex: 0 0 35%;
        flex: 0 0 35%;
        max-width: 35%;
        position: relative;
        width: 100%;
        padding-right: 15px;
        padding-left: 15px;
    }
    .nqt-col-sm-7 {
        -ms-flex: 0 0 65%;
        flex: 0 0 65%;
        max-width: 65%;
        position: relative;
        width: 100%;
        padding-right: 15px;
        padding-left: 15px;
        color: #6c757d !important;
    }
    hr {
        margin-top: 1rem;
        margin-bottom: 1rem;
        border: 0;
        border-top: 1px solid rgba(0, 0, 0, 0.1);
    }
    hr {
        box-sizing: content-box;
        height: 0;
        overflow: visible;
    }
    .mb-3,
    .my-3 {
        margin-bottom: 1rem !important;
    }
    /* .nqt--profile {
        margin-top: 20px;
    } */
    .nqt--mt1 {
        margin-top: 1rem !important;
    }
    .nqt--profile .card {
        position: relative;
        display: flex;
        flex-direction: column;
        min-width: 0;
        word-wrap: break-word;
        background-color: #fff;
        background-clip: border-box;
        border: 0 solid rgba(0, 0, 0, 0.125);
        border-radius: 0.25rem;
        box-shadow: 0 1px 3px 0 rgb(0 0 0 / 80%), 0 1px 2px 0 rgb(0 0 0 / 80%);
    }
    .nqt--profile .nqt-col-4 {
        -ms-flex: 0 0 33.333333%;
        flex: 0 0 33.333333%;
        max-width: 33.333333%;
    }
    .nqt--profile .card .card-body {
        flex: 1 1 auto;
        min-height: 1px;
        padding: 1rem;
    }
    .nqt--profile .card .card-body .card-content {
        text-align: center !important;
        align-items: center !important;
        -ms-flex-direction: column !important;
        flex-direction: column !important;
        display: -ms-flexbox !important;
        display: flex !important;
        text-align: center !important;
    }
    .nqt--profile .card .card-body .card-content .rounded-circle {
        border-radius: 50% !important;
        vertical-align: middle;
        border-style: none;
        width: 106px;
    }
    .nqt--profile .card .card-body .card-content .nqt-mt-3 {
        margin-top: 1rem !important;
    }
    .nqt--profile .card .card-body .card-content .nqt-mt-3 h4 {
        margin-bottom: 1rem !important;
    }
    .nqt--profile .card .card-body .card-content .nqt-mt-3 .text-secondary.mb-1 {
        margin-bottom: 1rem !important;
        color: #6c757d !important;
    }
    .nqt--profile .card .card-body .card-content .nqt-mt-3 .text-muted.font-size-sm {
        color: #6c757d !important;
        margin-bottom: 1rem !important;
    }
    .nqt--profile .card .card-body .card-content .nqt-mt-3 .btn.btn-primary {
        color: #fff;
        background-color: #007bff;
        border-color: #007bff;
    }
    .nqt--profile .card .card-body .card-content .nqt-mt-3 .btn {
        display: inline-block;
        font-weight: 400;
        color: #212529;
        text-align: center;
        vertical-align: middle;
        cursor: pointer;
        -webkit-user-select: none;
        -moz-user-select: none;
        -ms-user-select: none;
        user-select: none;
        background-color: transparent;
        border: 1px solid transparent;
        padding: 0.375rem 0.75rem;
        font-size: 1rem;
        line-height: 1.5;
        border-radius: 0.25rem;
        transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
    }
    .nqt--profile .card .card-body .card-content .nqt-mt-3 .btn.btn-outline-primary {
        color: #007bff;
        border-color: #007bff;
    }
    .list-group {
        display: -ms-flexbox;
        display: flex;
        -ms-flex-direction: column;
        flex-direction: column;
        padding-left: 0;
        margin-bottom: 0;
    }
    .card > .list-group:first-child .list-group-item:first-child {
        border-top-left-radius: 0.25rem;
        border-top-right-radius: 0.25rem;
    }
    .list-group-flush .list-group-item:first-child {
        border-top-width: 0;
    }
    .list-group-flush .list-group-item {
        border-right-width: 0;
        border-left-width: 0;
        border-radius: 0;
    }
    .list-group-item:first-child {
        border-top-left-radius: 0.25rem;
        border-top-right-radius: 0.25rem;
    }
    .align-items-center {
        -ms-flex-align: center !important;
        align-items: center !important;
    }
    .justify-content-between {
        -ms-flex-pack: justify !important;
        justify-content: space-between !important;
    }
    .flex-wrap {
        -ms-flex-wrap: wrap !important;
        flex-wrap: wrap !important;
    }
    .d-flex {
        display: -ms-flexbox !important;
        display: flex !important;
    }
    .list-group-item {
        position: relative;
        display: block;
        padding: 0.75rem 1.25rem;
        background-color: #fff;
        border: 1px solid rgba(0, 0, 0, 0.125);
    }
    h6.mb-0 {
        margin-bottom: 0 !important;
        font-size: 1rem;
    }
    h6.mb-0 .text-secondary {
        color: #6c757d !important;
    }
    .mr-2,
    .mx-2 {
        margin-right: 0.5rem !important;
    }
    svg {
        overflow: hidden;
        vertical-align: middle;
    }
    .card-tt.pc .row-tt {
        border: none;
        padding: 0;
    }
    .card-tt.pc .row-tt label {
        padding: 4px 0;
        border-bottom: 1px #eceef5 solid;
        width: 240px;
        font-size: 14px;
        font-weight: bold;
    }
    .card-tt.pc .row-tt label.tt-n {
        width: 240px;
    }
    .card-tt.pc .row-tt span {
        padding: 4px 0;
        width: calc(100% - 240px);
        border-bottom: 1px #eceef5 solid;
        text-align: right;
    }
    .tt-icon {
        width: 24px;
        height: 24px;
        margin: 5px 5px 5px 0;
    }
    .csp {
        cursor: pointer;
    }
    .cs {
        cursor: pointer;
        color: rgb(0 0 205);
    }
    .h4-thongke {
        font-size: 13px;
        background: #00b5ad;
        margin: 10px 0;
        padding: 5px 10px;
        color: #fff;
    }
    .card-avtar.pc {
        width: 340px;
    }
    .card-tt.pc {
        width: calc(100% - 340px);
        padding-left: 10px;
    }
    .dispdi {
        margin-top: 5px;
        color: #9b9c98;
        text-align: center;
    }
    .userName {
        text-transform: uppercase;
        font-size: 18px;
        font-weight: 700;
        color: #0071c5;
        margin-left: 10px;
    }
    .n-img {
        display: flex;
    }
    .n-img img {
        width: 17px;
    }
    /* show ALl class */
    .menu-switch-school {
        display: block;
        position: relative;
        width: 46px;
        height: 27px;
        border: 1px solid #dfdfdf;
        outline: 0;
        border-radius: 16px;
        box-sizing: border-box;
        background-color: #dfdfdf;
        transition: background-color 0.1s, border 0.1s;
        cursor: pointer;
    }
    .menu-switch-school:before {
        content: " ";
        position: absolute;
        top: 0;
        left: 0;
        width: 44px;
        height: 25px;
        border-radius: 15px;
        background-color: #fdfdfd;
        transition: transform 0.35s cubic-bezier(0.45, 1, 0.4, 1);
    }
    .menu-switch-school:after {
        content: " ";
        position: absolute;
        top: 0;
        left: 0;
        width: 24px;
        height: 24px;
        border-radius: 15px;
        background-color: #ffffff;
        box-shadow: 0 1px 3px rgba(0, 0, 0, 0.4);
        transition: transform 0.35s cubic-bezier(0.4, 0.4, 0.25, 1.35);
    }
    .menu-switch-school-on {
        border-color: #79c9ff;
        background-color: #79c9ff;
    }
    .menu-switch-school-on:before {
        border-color: #79c9ff;
        background-color: #79c9ff;
    }
    .menu-switch-school-on:after {
        transform: translateX(20px);
    }
    
    .manage--search-content--right {
        align-items: center;
        justify-content: flex-end;
        display: flex;
        width: 20%;
    }
    .top-content {
        margin-top: 5px;
    }
    .top-content.mb .manage--search-content--right {
        width: 50%;
    }
    .manage--search-content--right p{
        margin-right: 10px;
    }
    .manage--search-content--left {
        width: 50%;
        margin: 0 !important;
    }
    .manage--search-content {
        width: 30%;
        display: flex;
        justify-content: center;
        align-items: center;
    }
    .manage--search-content button {
        float: left;
        height: 35px;
        padding: 0px 10px;
        background-color: #0071c5;
        color: #fff;
        border: 0;
        border-radius: 5px;
        font-weight: bold;
        min-width: 200px;
        font-size: 13px;
        height: 36px;
    }
</style>



// WEBPACK FOOTER //
// src/components/manage/attendance/present.vue